/**
 * Configuração de Providers com Suporte a Etiquetas
 * 
 * Define quais providers têm implementação completa do sistema de etiquetas.
 * Novos providers devem ser adicionados aqui conforme forem implementados.
 * 
 * Providers implementados:
 * - waha: Implementação completa (sincronização bidirecional)
 * 
 * Providers pendentes (placeholders preparados):
 * - z-api
 * - evolution
 * - chatwoot
 */

/**
 * Lista de slugs de providers que têm suporte completo a etiquetas
 * Manter sincronizado com implementações nas Edge Functions provider-proxy e send-message
 */
export const LABELS_SUPPORTED_PROVIDERS = ['waha'] as const;

/**
 * Tipo para providers suportados (inferido do array)
 */
export type LabelsSupportedProvider = typeof LABELS_SUPPORTED_PROVIDERS[number];

/**
 * Verifica se um provider suporta o sistema de etiquetas
 * 
 * @param providerSlug - Slug do provider (ex: 'waha', 'z-api', 'evolution')
 * @returns true se o provider tem suporte completo a etiquetas
 * 
 * @example
 * // Uso em componentes
 * if (isLabelsSupported(conversation.inbox.provider_slug)) {
 *   // Renderiza seção de etiquetas
 * }
 */
export const isLabelsSupported = (providerSlug: string | null | undefined): boolean => {
  if (!providerSlug) return false;
  return LABELS_SUPPORTED_PROVIDERS.includes(providerSlug as LabelsSupportedProvider);
};
